import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import TextTooltipOnHover from '../../../Popover/Preset/TextTooltipOnHover';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumFolderDataIcon from '../../../GallectionFolderDropdown/_partials/PremiumFolderDataIcon';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import s from './FolderCardFooter.scss';
var FolderCardFooter = function (_a) {
    var _b, _c, _d;
    var folder = _a.folder, size = _a.size, className = _a.className, totalDeviationCount = _a.totalDeviationCount, isLocked = _a.isLocked, statsClassName = _a.statsClassName, withCommentsCount = _a.withCommentsCount, withPremiumShownNextToTitle = _a.withPremiumShownNextToTitle, withPrice = _a.withPrice, oneLineDescription = _a.oneLineDescription, showCountsWithoutCaptions = _a.showCountsWithoutCaptions, children = _a.children, t = _a.t;
    var isPaid = ((_b = folder.premiumFolderData) === null || _b === void 0 ? void 0 : _b.type) === 'paid';
    var withSubscribersCount = isPaid;
    var formattedDollarPrice = normalizePremiumFolderData(folder.premiumFolderData).formattedDollarPrice;
    return (React.createElement("div", { className: classnames(s['root'], s[size], oneLineDescription && s['one-line-description'], className) },
        React.createElement("div", { className: s['description'] },
            React.createElement("div", { className: s['name'] },
                withPremiumShownNextToTitle && (React.createElement(PremiumFolderDataIcon, { size: IconSize.SMALL, className: s['premium-icon'], premiumFolderData: folder.premiumFolderData })),
                React.createElement(Heading, { className: s['folder-name'], title: folder.name }, folder.name),
                isLocked && (React.createElement(TextTooltipOnHover, { className: s['lock-icon'], tooltipText: t('folderCard.locked'), positionFixed: true, width: 220 },
                    React.createElement(LockIcon, { size: IconSize.MEDIUM, condensed: true }))),
                withPrice && isPaid && (React.createElement("span", { className: s['price'] }, formattedDollarPrice))),
            React.createElement("div", { className: classnames(s['stats'], statsClassName) },
                showCountsWithoutCaptions
                    ? totalDeviationCount
                    : t('folderCard.stats.artworks', {
                        count: totalDeviationCount,
                    }),
                withCommentsCount && !withSubscribersCount && (React.createElement(React.Fragment, null,
                    ' | ',
                    showCountsWithoutCaptions
                        ? folder.commentCount
                        : t('folderCard.stats.comments', {
                            count: folder.commentCount,
                        }))),
                withSubscribersCount && (React.createElement(React.Fragment, null,
                    ' | ',
                    showCountsWithoutCaptions
                        ? (_c = folder.premiumFolderData) === null || _c === void 0 ? void 0 : _c.numSubscribers
                        : t('folderCard.stats.subscribers', {
                            count: (_d = folder.premiumFolderData) === null || _d === void 0 ? void 0 : _d.numSubscribers,
                        }))))),
        children));
};
export default withTranslation()(FolderCardFooter);
//# sourceMappingURL=FolderCardFooter.js.map